import React from "react";

import Corpo from "../components/Corpo";
import { Link } from "react-router-dom";

export default function TabSelTipo(props) {
  let getCategoryId = () => {
    return props.location.pathname.replace("/tab/type/", "");
  };

  return (
    <Corpo {...props}>
      <div name="tab-inicio" className="view-container tab-content">
        <div className="view-jogo tab-selecao-conteudo pane pane-game">
          <div
            className="padding scroll-content ionic-scroll has-tabs-top"
            style={{ top: "56px" }}
          >
            <div className="scroll">
              <h2>Modo de Jogo</h2>

              <Link
                className="button button-full button-lg ng-binding"
                to={"/tab/theme/single/" + getCategoryId()}
              >
                Single Player
              </Link>

              <Link
                className="button button-full button-lg ng-binding"
                to={"/tab/theme/multi/" + getCategoryId()}
              >
                Multi Player
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Corpo>
  );
}
